import React, { useEffect, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import Locate from "../../images/locate.svg";
import BackButton from "../bars/BackButton";
import { convert_24_to_12 } from "../../utils/util";

function HotelGuideItem() {
  const location = useLocation();
  const state = location.state || {};
  const [isExpanded, setIsExpanded] = useState(false);
  const [isTruncated, setIsTruncated] = useState(false);
  const descriptionRef = useRef(null);

   //Seemore/less
   useEffect(() => {
    const checkDescriptionLength = () => {
      if (descriptionRef.current) {
        const lineHeight = parseInt(window.getComputedStyle(descriptionRef.current).lineHeight, 10);
        const maxHeight = lineHeight * 15;
        const contentHeight = descriptionRef.current.scrollHeight;
        setIsTruncated(contentHeight > maxHeight);
      }
    };

    checkDescriptionLength();
    window.addEventListener('resize', checkDescriptionLength);
    return () => {
      window.removeEventListener('resize', checkDescriptionLength);
    };
  }, []);

  const handleToggle = () => {
    setIsExpanded(prev => !prev);
  };

  return (
    <div>
      <div className="mb-28">
        <div
          style={{
            width: "100%",
            height: "150px",
            maxHeight: "200px",
            backgroundImage: `url(${state.image})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            position: "relative",
          }}
        >
           <div className="absolute top-3 max-sm:left-3 left-3">
          <BackButton whiteTheme={true}  />
        </div>
        </div>
       
        <div className="section-wrap mx-4 mt-6 sm:mt-14">
          <div className="guestName sm:text-center text-left flex items-center">
            <span className="guestName sm:text-center text-left truncate w-[auto] max-w-[95%] ">{state.name}</span>
            </div>
          {state.close_time && state.start_time ?
            <div className="pt-[8px] text-left text-[10px] text-[#9A9A9A] font-medium">
              (  Working hours : {convert_24_to_12(state?.start_time ? state?.start_time:'')} - {convert_24_to_12(state?.close_time ? state?.close_time:'')} )
            </div> : " "
           } 
          {/* <div className="mt-4 guideP">{state.description}</div> */}
          <div className='mt-4 guideP'>
            <p
              className={`${isExpanded ? 'expanded' : 'truncated'}`}
              ref={descriptionRef}
              style={{
                maxHeight: isExpanded ? 'none' : '16em',
                overflow: 'hidden',
              }}
            >
              {state.description}
            </p>
            {isTruncated && (
              <button onClick={handleToggle}className="text-[#6b6bec] cursor-pointer bg-transparent  font-[500]">
                {isExpanded ? 'See less...' : 'See more...'}
              </button>
            )}
          </div>
          {/* <div className="my-4 text-[#D6D6D6] font-semibold text-base">
            Instructions
          </div>
          <div className="text-[#D6D6D6] text-sm">
            Wear Polyster Clothes In the Pool
          </div> */}
          {/* <div className="mt-8 flex space-x-4 items-center"> */}
            {/* <div className="text-[15px] font-semibold text-[#FFF]">Locate </div> */}
            {/* <img src={Locate} /> */}
          {/* </div> */}
          {/* <div className="mt-2 flex mx-0 sm:mx-auto sm:justify-center justify-start rounded-sm overflow-hidden">
            <img className="h-20 object-cover w-1/3" src={state.image} />
            <div className="py-3 pl-3 pr-6 flex-nowrap w-full text-center flex items-center justify-center  bg-[#FFFFFF]">
              <div className="text-xs font-medium text-[#000]">{state.name}</div>
              
            </div>
          </div> */}
          {state.map ? 
          <div className=" w-[100%]  " style={{marginTop:'30px'}}>
            <p className="text-[15px] font-semibold mb-2">{state.name} Map</p>
            <img className='w-[100%] h-[200px] object-cover rounded-sm border mb-[20px]' src={state.map}></img>
          </div>
           : " "}
        </div>
      </div>
    </div>
  );
}

export default HotelGuideItem;
